import type { InvestmentCompany, InvestmentStatus } from '../types';

/** ISO 3166-1 alpha-2, stored lowercase. */
export function normalizeCountryCode(raw: string | undefined | null): string | undefined {
  if (raw == null || typeof raw !== 'string') return undefined;
  const c = raw.trim().toLowerCase();
  return /^[a-z]{2}$/.test(c) ? c : undefined;
}

/** SVG flags via [flagcdn](https://flagcdn.com). */
export function flagSvgUrlForCountryCode(code: string | undefined | null): string | null {
  const c = normalizeCountryCode(code);
  if (!c) return null;
  return `https://flagcdn.com/${c}.svg`;
}

export function getInvestmentStatus(company: InvestmentCompany): InvestmentStatus {
  const s = company.investmentStatus;
  if (s === 'exit' || s === 'dead' || s === 'active') return s;
  return 'active';
}

export function isInvestmentInactive(company: InvestmentCompany): boolean {
  const s = getInvestmentStatus(company);
  return s === 'exit' || s === 'dead';
}
